import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
const EASE = [0.23, 1, 0.32, 1] as const;

/**
 * Abstract architectural composition: overlapping planes, a copper diagonal
 * band and hairline drafting strokes. Layers fade in on slightly different
 * offsets to read as depth rather than decoration.
 */
export function Sculpture() {
  const reduce = useReducedMotion();
  const layer = (delay: number, y = 18) => ({
    initial: reduce ? {
      opacity: 0
    } : {
      opacity: 0,
      y
    },
    animate: {
      opacity: 1,
      y: 0
    },
    transition: {
      duration: 0.3,
      ease: EASE,
      delay
    }
  });
  return <svg viewBox="0 0 520 640" className="w-full h-full" aria-hidden="true" focusable="false" preserveAspectRatio="xMidYMid meet" data-id="element-131" data-mp="9gtvt6ota7vu">
      {/* drafting grid */}
      <motion.g stroke="#f4ede1" strokeOpacity="0.1" strokeWidth="1" {...layer(0.05, 0)} data-id="element-132" data-mp="3vns6w97nllgd">
        {[80, 180, 280, 380, 480].map(x => <line key={x} x1={x} y1="20" x2={x} y2="620" data-id="element-133" data-mp="4fw5g6tne7j9" />)}
        {[120, 260, 400, 540].map(y => <line key={y} x1="20" y1={y} x2="500" y2={y} data-id="element-134" data-mp="35gr4oj252mk0" />)}
      </motion.g>

      {/* large receding plane */}
      <motion.polygon points="60,520 60,140 330,60 330,470" fill="#152741" stroke="#f4ede1" strokeOpacity="0.16" {...layer(0.1, 26)} data-id="element-135" data-mp="30lvc9hszpx6d" />

      {/* copper diagonal band */}
      <motion.polygon points="20,470 480,110 480,168 20,528" fill="#b57a4a" fillOpacity="0.92" {...layer(0.16, 22)} data-id="element-136" data-mp="2ms44aduwqlcr" />

      {/* forward triangle */}
      <motion.polygon points="210,600 430,210 470,560" fill="#0b1628" fillOpacity="0.85" stroke="#b57a4a" strokeOpacity="0.7" strokeWidth="1.25" {...layer(0.22, 30)} data-id="element-137" data-mp="2hr6kxxy5vl9o" />

      {/* cream sliver */}
      <motion.polygon points="330,60 400,96 400,300 330,258" fill="#f4ede1" fillOpacity="0.9" {...layer(0.28, 18)} data-id="element-138" data-mp="232si3n0qvwt4" />

      {/* hairline construction strokes */}
      <motion.g stroke="#b57a4a" strokeOpacity="0.55" strokeWidth="1" fill="none" {...layer(0.34, 12)} data-id="element-139" data-mp="21472dmikgtw">
        <line x1="60" y1="140" x2="470" y2="560" data-id="element-140" data-mp="brytpj3o9ifv" />
        <line x1="330" y1="60" x2="210" y2="600" data-id="element-141" data-mp="bs785ffg0vt6" />
        <circle cx="330" cy="60" r="4" fill="#b57a4a" data-id="element-142" data-mp="gqifnji9mu88" />
        <circle cx="210" cy="600" r="4" fill="#b57a4a" data-id="element-143" data-mp="gq0ce2x6rfqt" />
        <circle cx="470" cy="560" r="4" data-id="element-144" data-mp="3f8xl6e9g094d" />
      </motion.g>

      {/* thin cream outline rectangle, offset for depth */}
      <motion.rect x="140" y="230" width="300" height="300" fill="none" stroke="#f4ede1" strokeOpacity="0.28" strokeWidth="1" {...layer(0.4, 10)} data-id="element-145" data-mp="3k8a3clpdcs0m" />
    </svg>;
}